/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

/**
 * Defines a utlity to return Signal Symbol based on the CIMSymbol feature
 * 
 *   import {createSignalSymbol} from '@ion/dls/src/maps/symbols/SignalSymbol';
 * 
 *   const renderer = {
 *     type : 'CIMPointSymbol',
 *     symbolLayers: [
 *       createSignalSymbol()
 *     ]
 *    };
 */
export const createSignalSymbol = (size: number = 17, color: number[] = [51, 51, 51]) => {
  return {
    type               : 'CIMVectorMarker',
    enable             : true,
    anchorPointUnits   : 'Relative',
    dominantSizeAxis3D : 'Y',
    size,
    billboardMode3D    : 'FaceNearPlane',
    frame              : {xmin: 0, ymin: 0, xmax: 21, ymax: 21},
    markerGraphics     : [
      {
        type     : 'CIMMarkerGraphic',
        geometry : {
          rings : [
            [
              [14.49, 9.37],
              [14.32, 9.4],
              [14.09, 9.58],
              [14, 9.86],
              [14, 9.87],
              [14.12, 10.19],
              [14.5, 10.7],
              [14.77, 11.26],
              [14.94, 11.87],
              [15, 12.5],
              [14.94, 13.13],
              [14.77, 13.74],
              [14.5, 14.3],
              [14.12, 14.81],
              [14, 15.14],
              [14.09, 15.42],
              [14.32, 15.6],
              [14.5, 15.63],
              [14.86, 15.47],
              [15.35, 14.81],
              [15.71, 14.08],
              [15.93, 13.3],
              [16, 12.5],
              [15.93, 11.7],
              [15.7, 10.92],
              [15.35, 10.19],
              [14.86, 9.53],
              [14.49, 9.37]
            ],
            [
              [15.97, 8],
              [15.94, 8],
              [15.68, 8.08],
              [15.49, 8.29],
              [15.46, 8.57],
              [15.58, 8.82],
              [16.19, 9.63],
              [16.63, 10.53],
              [16.91, 11.5],
              [17, 12.5],
              [16.91, 13.51],
              [16.63, 14.48],
              [16.19, 15.38],
              [15.58, 16.18],
              [15.46, 16.44],
              [15.49, 16.71],
              [15.67, 16.92],
              [15.94, 17],
              [16.34, 16.84],
              [17.05, 15.89],
              [17.57, 14.83],
              [17.89, 13.68],
              [18, 12.5],
              [17.89, 11.32],
              [17.57, 10.18],
              [17.05, 9.12],
              [16.34, 8.16],
              [15.97, 8]
            ]
          ]
        },
        symbol : {
          type         : 'CIMPolygonSymbol',
          symbolLayers : [
            {
              type        : 'CIMSolidStroke',
              enable      : true,
              capStyle    : 'Round',
              joinStyle   : 'Round',
              lineStyle3D : 'Strip',
              miterLimit  : 10,
              width       : 0,
              color       : [0, 0, 0, 255]
            },
            {
              type   : 'CIMSolidFill',
              enable : true,
              color  : [...color, 255]
            }
          ]
        }
      }
    ],
    scaleSymbolsProportionally : true,
    respectFrame               : true,
    colorLocked                : true,
    rotateClockwise            : true,
    offsetY                    : -1.4,
    offsetX                    : -1
  };
};
